import script from "./genuine-software-usage.vue?vue&type=script&lang=ts&setup=true"
export * from "./genuine-software-usage.vue?vue&type=script&lang=ts&setup=true"

import "./genuine-software-usage.vue?vue&type=style&index=0&id=a2be23c6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2be23c6"]])

export default __exports__